// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active-item[data-v-36c3e1a0]{border-color:#0bb7af!important}.active-item[data-v-36c3e1a0] .v-list-item__title{color:#0bb7af!important}", ""]);
// Exports
module.exports = exports;
